module.exports = __webpack_public_path__ + "img/4.1c82e52d.svg";